module.exports = __webpack_public_path__ + "img/circle.24f947bf.svg";